export default __webpack_public_path__ + "static/media/odd.952019f1.png";